<template>
  <div class="map-container">
    <div id="mapImages"></div>
    <!-- 取水点信息弹框 -->
    <el-dialog
      class="details"
      :visible.sync="showDetails"
      :show-close="false"
      @open="handleDialogOpen"
    >
      <!-- 自定义标题栏 -->
      <div slot="title" class="dialog-title">
        <span>{{ point_title }}</span>
        <i class="el-icon-close" @click="showDetails = false"></i>
      </div>
      <div class="details-content" v-show="point_title == '地表水质检测数据详情'">
        <el-row>
          <span class="label">任务点名称:</span>
          <span class="text">余杭区西险大塘苕溪大桥东2KM水域</span>
        </el-row>
        <el-row>
          <span class="label">任务点编号:</span>
          <span class="text">3301100000001</span>
        </el-row>
        <el-row>
          <span class="label">高光谱设备编号:</span>
          <span class="text">SCI-VN100F</span>
        </el-row>
        <el-row>
          <span class="label">作业车车牌号:</span>
          <span class="text">浙A0KX71</span>
        </el-row>
        <el-row>
          <span class="label">风速:</span>
          <span class="text">2.41m/s</span>
        </el-row>
        <el-row>
          <span class="label">雨量:</span>
          <span class="text">0.0mm</span>
        </el-row>
        <el-row>
          <span class="label">无人机飞行作业时长:</span>
          <span class="text">8分30秒</span>
        </el-row>
        <el-row>
          <span class="label">无人机飞行距离:</span>
          <span class="text">2km</span>
        </el-row>
        <el-row>
          <span class="label">巡检周期:</span>
          <span class="text">30天</span>
        </el-row>
        <el-row>
          <span class="label">上次巡检时间:</span>
          <span class="text">-</span>
        </el-row>
        <el-row>
          <span class="label">任务时间:</span>
          <span class="text">-</span>
        </el-row>
        <el-row>
          <span class="label">地理（河段）位置:</span>
          <span class="text">余杭区西险大塘苕溪大桥东2KM水域</span>
        </el-row>
        <el-row>
          <span class="label">起始点经纬度:</span>
          <span class="text">{{ start_location }}</span>
        </el-row>
        <el-row>
          <span class="label">结束点经纬度:</span>
          <span class="text">{{ end_location }}</span>
        </el-row>
        <div class="details-title">反演结果（拼图）:</div>
        <figure
          class="image-list"
          v-for="(info, index) in url_info"
          :key="index"
        >
          <el-image
            style="width: 200px"
            :src="info.url"
            :preview-src-list="url_list"
          >
          </el-image>
          <figcaption class="description">{{ info.description }}</figcaption>
        </figure>
      </div>
      <div class="details-content" v-show="point_title == '无人机巡检反演详情'">
        <div class="details-title">单张环境图:</div>
        <div class="environmental">
          <el-image
            style="width: 200px"
            :src="environmental_image"
            :preview-src-list="[environmental_image]"
          >
          </el-image>
        </div>
        <div class="details-title">高光谱单张反演图:</div>
        <figure
          class="image-list"
          v-for="(info, index) in url_info"
          :key="index"
        >
          <figcaption class="description">{{ info.description }}</figcaption>
          <el-image
            style="width: 200px"
            :src="info.url"
            :preview-src-list="url_list"
          >
          </el-image>
          <figcaption v-if="pointsObj.isWrong && index == 0">
            根据上图反演结果判断，此区域总氮指标疑似超标，需用多光谱设备进行检测。
          </figcaption>
        </figure>
        <el-row>
          <span class="label">照片中心点经纬度:</span>
          <span class="text">{{ pointsObj.location }}</span>
        </el-row>
        <el-row>
          <span class="label">采集时间:</span>
          <span class="text">2025年9月24日 15:34:24</span>
        </el-row>
        <div v-if="pointsObj.isWrong">
          <div class="details-title">取水照片:</div>
          <figure
            class="image-list"
            v-for="(url, index) in water_photo_info"
            :key="index"
          >
            <el-image
              style="width: 200px"
              :src="url"
              :preview-src-list="water_photo_List"
            >
            </el-image>
          </figure>
          <el-row>
            <span class="label">多光谱设备编号:</span>
            <span class="text">N238V846A65CUNWE</span>
          </el-row>
          <el-row>
            <span class="label">车载多光谱设备检测:</span>
            <span class="text">-</span>
          </el-row>
          <div class="table-row">
            <span class="label">多光谱设备检测数据:</span>
            <el-table :data="m_tableData">
              <el-table-column
                v-for="item in multispectral_tableData"
                :key="item.label"
                :label="item.label"
                :prop="item.label"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  {{ scope.row[item.label] }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-row>
            <span class="label">化学法检测机构:</span>
            <span class="text">杭州希玛诺光电技术股份有限公司</span>
          </el-row>
          <div class="table-row">
            <div class="label">化学法检测数据:</div>
            <el-table :data="tableData">
              <el-table-column
                v-for="item in chemical_tableData"
                :key="item.label"
                :label="item.label"
                :prop="item.label"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  {{ scope.row[item.label] }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 拍摄点信息窗体 -->
    <div class="point-infoWindow" ref="pointInfoWindow" v-show="showInfoWindow">
      <i class="delta" />
      <!-- <div class="pointInfo-title">
        <div>设备信息</div>
        <i class="el-icon-close" @click="closePointWindow" />
      </div> -->
      <div class="pointInfo-content">
        <el-row type="flex">
          <el-col style="width: 68px">面积:</el-col>
          <el-col v-if="pointsObj.waterArea"
            >{{ pointsObj.waterArea }} 平方米</el-col
          >
          <el-col v-else>-</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 68px">时间:</el-col>
          <el-col>{{ pointsObj.shootingTime }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 68px">经纬度:</el-col>
          <el-col>{{ pointsObj.location }}</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
import mydata from "./data.json";
const MARKER_STYLE = {
  red: `<div class='red-marker'></div>`,
  green: `<div class='blue-marker'></div>`,
  task_start_con: "https://webapi.amap.com/theme/v1.3/markers/n/start.png",
  task_end_icon: "https://webapi.amap.com/theme/v1.3/markers/n/end.png",
};
export default {
  name: "MapImages",
  data() {
    return {
      map: null,
      showInfoWindow: false,
      showDetails: false,
      pointMarkerAll: [],
      taskMarkerAll: [],
      pointsObj: {},
      url_info: [],
      url_list: [],
      environmental_image: "",
      water_photo_info: [],
      water_photo_List: [],
      point_title: "地表水质检测数据详情",
      vehicleLocal: [],
      vehicleMarkerList: [],
      vehicleMarker: [],
      uavMarker: "",
      letMarker: "",
      powerStateMarker: "",
      plateNumMarker: "",
      chemical_tableData: [
        { label: "CODmn（高锰酸盐）", value: "3.17" },
        { label: "TN（总氮）", value: "1.79" },
        { label: "TP（总磷）", value: "0.1" },
        { label: "NH3N（氨氮）", value: "0.65" },
      ],
      multispectral_tableData: [
        { label: "CODmn（高锰酸盐）", value: "2.84" },
        { label: "TN（总氮）(COD)", value: "2.03" },
        { label: "TP（总磷）", value: "0.104" },
        { label: "NH3N（氨氮", value: "0.64" },
      ],
      district_name_list: [],
      start_location: [],
      end_location: [],
    };
  },
  computed: {
    tableData() {
      let tableData = [{}];
      this.chemical_tableData.forEach((item) => {
        tableData[0][item.label] = item.value;
      });
      return tableData;
    },
    m_tableData() {
      let m_tableData = [{}];
      this.multispectral_tableData.forEach((item) => {
        m_tableData[0][item.label] = item.value;
      });
      return m_tableData;
    },
  },
  mounted() {
    this.initMap();
    this.loadAllData();
    this.getVehicleLocation();
    // let demo_list = [];
    // demo_list = mydata.points.filter((item) => (Number(item.id) - 1) % 3 == 0);
    // // demo_list.forEach(item=>{
    // //   item.parameters
    // // })
    // console.log(demo_list);
  },
  methods: {
    handleDialogOpen() {
      // 弹框打开后重置滚动位置
      this.$nextTick(() => {
        // 选择第一个类名为"el-dialog__body"的元素
        const element = document.querySelector(".el-dialog__body");
        element.scrollTop = 0;
      });
    },
    //获取车辆定位信息
    async getVehicleLocation() {
      let { data: res } = await this.$axios.get(
        "/api/v3/maintain/monitor/vehicle"
      );
      if (res.code == 1) {
        this.vehicleLocal = res.data;
        this.addVehicleMarker();
      } else {
        this.$message.warning(res.msg);
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let data = this.vehicleLocal;
      if (this.vehicleMarker.length > 0) {
        this.map.remove(this.vehicleMarker);
        this.vehicleMarkerList = [];
        this.vehicleMarker = [];
      }
      for (let i = 0; i < data.length; i++) {
        this.letMarker = "";
        this.powerStateMarker = "";
        this.plateNumMarker = "";
        this.uavMarker = "";
        if (data[i].powerState == 1) {
          let powerContent =
            "<img style='width:14px;height:18px'  src='" +
            require("@/assets/images/monitor/icon-powering.png") +
            "'/>";
          this.powerStateMarker = new AMap.Marker({
            zIndex: 200,
            content: powerContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-30, -12),
            map: this.map,
          });
        }
        if (data[i].vin == "LS4ASG2E1KG172338") {
          let uavContent =
            "<img style='width:22px;height:22px'  src='" +
            require("@/assets/images/monitor/icon-uav.png") +
            "'/>";
          this.uavMarker = new AMap.Marker({
            zIndex: 200,
            content: uavContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-16, 8),
            map: this.map,
          });
        }
        if (data[i].vehicleState == 1) {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-offline-2.png")
              : require("@/assets/images/monitor/car-offline.png");
          this.letMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            clickable: true,
            zIndex: 200,
            angel: -90,
          });
          let plateNumContent =
            "<div style='position:relative'><img style='width:80px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:12px;top:3px'>" +
            data[i].plateNum +
            "</span></div>";
          this.plateNumMarker = new AMap.Marker({
            zIndex: 120,
            content: plateNumContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: this.map,
          });
        } else {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-online-2.png")
              : require("@/assets/images/monitor/car-online.png");
          this.letMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            zIndex: 200,
            clickable: true,
            angel: -90,
          });
          let plateContent =
            "<div style='position:relative'><img style='width:80px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:12px;top:3px'>" +
            data[i].plateNum +
            "</span></div>";
          this.plateNumMarker = new AMap.Marker({
            zIndex: 120,
            content: plateContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: this.map,
          });
          // 判断车辆方向
          this.letMarker.moveAlong(data[i].directionLnglat, 50); //车辆行驶方向
        }
        this.letMarker.content = data[i]; // 车辆信息窗体内容
        this.vehicleMarker.push(this.uavMarker);
        this.vehicleMarker.push(this.letMarker);
        this.vehicleMarker.push(this.powerStateMarker);
        this.vehicleMarker.push(this.plateNumMarker);
        this.vehicleMarkerList.push({
          vin: data[i].vin,
          lnglat: data[i].lnglat,
          vehicle: this.letMarker,
          plateNum: this.plateNumMarker,
          // oil: this.oilStateMarker,
          power: this.powerStateMarker,
        });
        AMap.event.addListener(this.letMarker, "click", function(e) {
          this.vin = e.target.content.vin;
          this.deptId = e.target.content.deptId;
          this.monitorLnglat = e.target.content.lnglat;
          //   //   获取车辆详情数据
          //   this.getVehicleInfoWindow(this.vin, this.deptId);
        });
        AMap.event.addListener(this.letMarker, "mouseover", function(e) {
          e.target.setTop(true);
        });
        AMap.event.addListener(this.letMarker, "mouseout", function(e) {
          e.target.setTop(false);
        });
      }
      this.map.add(this.vehicleMarker);
    },
    // 加载所有数据
    loadAllData() {
      this.handlePointData("taskPoint");
      this.handlePointData("point");
    },
    // 显示拍摄点标记
    showPointMarkers() {
      this.map.add(this.pointMarkerAll);
      this.map.remove(this.taskMarkerAll);
    },
    // 显示任务点标记
    showTaskMarkers() {
      this.map.remove(this.pointMarkerAll);
      this.map.add(this.taskMarkerAll);
      if (this.pointInfoWindow) {
        this.pointInfoWindow.close();
      }
    },
    // 处理点数据
    handlePointData(type) {
      const data = type === "point" ? mydata.sparse_points : mydata.taskPoints;
      if (!data || data.length === 0) {
        this.pointMarkerAll = [];
        this.taskMarkerAll = [];
        return;
      }
      let completedCount = 0;
      const markers = [];
      if (type === "point") {
        // 处理sparse_points
        data.forEach((point) => {
          AMap.convertFrom(point.location, "gps", (status, result) => {
            if (status === "complete" && result.info === "ok") {
              const location = result.locations[0];
              const marker = this.createMarker(point, location, type);
              markers.push(marker);
            }
            completedCount++;
            if (completedCount === data.length) {
              this.finalizeMarkers(markers, type);
            }
          });
        });
      } else {
        // 处理taskPoints
        data.forEach((point) => {
          // 收集需要转换的坐标：起点和终点
          const coordinates = [point.start_location, point.end_location];
          AMap.convertFrom(coordinates, "gps", (status, result) => {
            if (status === "complete" && result.info === "ok") {
              const startLocation = result.locations[0];
              const endLocation = result.locations[1];
              this.start_location = startLocation;
              this.end_location = endLocation;
              // 创建起点标记
              const startMarker = this.createMarker(
                point,
                startLocation,
                type,
                "start"
              );
              markers.push(startMarker);
              // 创建终点标记
              const endMarker = this.createMarker(
                point,
                endLocation,
                type,
                "end"
              );
              markers.push(endMarker);

              // 如果需要，可以在这里创建一条从起点到终点的线段
              // this.createPolyline(startLocation, endLocation);
            }
            completedCount++;
            if (completedCount === data.length) {
              this.finalizeMarkers(markers, type);
            }
          });
        });
      }
    },
    // 创建标记
    createMarker(point, location, type, icon_type) {
      const isTaskPoint = type === "taskPoint";
      const taskIcon =
        icon_type === "end"
          ? MARKER_STYLE.task_end_icon
          : MARKER_STYLE.task_start_con;
      let myIcon = new AMap.Icon({
        size: new AMap.Size(19, 31), // 图标尺寸
        image: taskIcon,
        imageSize: new AMap.Size(19, 31), // 根据所设置的大小拉伸或压缩图片
      });
      const marker = new AMap.Marker({
        zIndex: 200,
        position: location,
        icon: isTaskPoint ? myIcon : null,
        content: isTaskPoint
          ? null
          : point.isWrong
          ? MARKER_STYLE.red
          : MARKER_STYLE.green,
      });
      let start_location = icon_type === "start" ? location : "-";
      let end_location = icon_type === "end" ? location : "-";
      // 存储数据
      marker.content = {
        ...point,
        location: location,
        start_location: start_location,
        end_location: end_location,
        id: point.id,
      };
      // 绑定事件
      if (isTaskPoint) {
        marker.on("click", this.handleTaskMarkerClick);
      } else {
        marker.on("mouseover", (e) => this.handlePointMarkerHover(e, marker));
        marker.on("mouseout", () => this.closeInfoWindow());
        marker.on("click", this.handlePointMarkerClick);
      }
      return marker;
    },
    // 处理任务点标记点击
    handleTaskMarkerClick(e) {
      this.resetDisplayData();
      this.pointsObj = { ...e.target.content };
      this.point_title = "地表水质检测数据详情";
      const { parameters } = e.target.content;
      this.processImageData(parameters, "task");
      // 延迟显示弹框，确保图片已处理
      setTimeout(() => {
        this.showDetails = true;
      }, 300);
    },
    // 处理拍摄点标记悬停
    handlePointMarkerHover(e, marker) {
      this.pointsObj = { ...e.target.content };
      this.showInfoWindow = true;
      this.pointInfoWindow.open(this.map, marker.getPosition());
    },
    closeInfoWindow() {
      this.showInfoWindow = false;
      if (this.pointInfoWindow) {
        this.pointInfoWindow.close();
      }
    },
    // 处理拍摄点标记点击
    handlePointMarkerClick(e) {
      console.log(e.target.content.id);
      this.resetDisplayData();
      this.point_title = "无人机巡检反演详情";
      this.pointsObj = { ...e.target.content };
      const { parameters, environmental_image } = e.target.content;
      if (this.pointsObj.isWrong) {
        const { water_photo } = e.target.content;
        this.processImageData(water_photo, "point");
      } else {
        this.processImageData(parameters, "point");
      }
      this.processEnvironmentalImage(environmental_image);
      // 延迟显示弹框，确保图片已处理
      setTimeout(() => {
        this.showDetails = true;
      }, 100);
    },
    // 处理图片数据
    async processImageData(list, type) {
      if (!list || !Array.isArray(list)) {
        if (this.pointsObj.isWrong) {
          this.water_photo_info = [];
          this.water_photo_List = [];
        }
        this.url_info = [];
        this.url_list = [];
        return;
      }
      let url = "";
      const basePath = type === "task" ? "task" : "points";
      this.url_info = this.pointsObj.parameters.map((item, i) => {
        const fileName = this.extractFileName(item.url);
        try {
          url = require(`@/assets/images/water-test/${basePath}/${fileName}`);
        } catch (error) {
          url = "";
        }
        return {
          url: url,
          description: `图${i + 1}. ${item.name}`,
        };
      });
      this.url_list = this.url_info.map((item) => item.url);
      if (this.pointsObj.isWrong) {
        this.water_photo_info = this.pointsObj.water_photo.map((item) => {
          const fileName = this.extractFileName(item.url);
          try {
            url = require(`@/assets/images/water-test/${basePath}/${fileName}`);
          } catch (error) {
            url = "";
          }
          return url;
        });
        this.water_photo_List = this.water_photo_info;
      }
    },
    // 处理环境图片
    processEnvironmentalImage(environmentalImage) {
      const fileName = this.extractFileName(environmentalImage);
      try {
        this.environmental_image = require(`@/assets/images/water-test/points/${fileName}`);
      } catch (error) {
        this.environmental_image = "";
      }
    },
    // 提取文件名
    extractFileName(url) {
      return url ? url.split("/").pop() : null;
    },
    // 重置显示数据
    resetDisplayData() {
      this.pointsObj = {};
      this.url_info = [];
      this.url_list = [];
      this.water_photo_info = [];
      this.water_photo_List = [];
      this.environmental_image = "";
    },
    // 完成标记处理
    finalizeMarkers(markers, type) {
      const markerKey = type === "point" ? "pointMarkerAll" : "taskMarkerAll";
      this[markerKey] = markers;
      this.initZoomWatcher();
      this.adjustMapView();
    },
    // 监控地图缩放级别
    initZoomWatcher() {
      this.showTaskMarkers();
      this.map.on("zoomend", () => {
        const zoom = this.map.getZoom();
        console.log("缩放级别变化:", zoom);
        if (zoom > 14) {
          this.showPointMarkers();
        } else {
          this.map.remove(this.pointMarkerAll);
          this.showTaskMarkers();
        }
      });
    },
    adjustMapView() {
      this.$nextTick(() => {
        // 使用setFitView的第四个参数固定缩放级别
        const allMarkers = [...this.pointMarkerAll, ...this.taskMarkerAll];
        this.map.setFitView(allMarkers, false, [0, 0, 0, 0], 8);
      });
    },
    // 颜色辅助方法
    getColorByAdCode(adCode) {
      let colors = {};
      if (!colors[adCode]) {
        let gb = Math.random() * 155 + 50;
        colors[adCode] = "rgba(" + gb + "," + gb + ",255,.4)";
      }
      return colors[adCode];
    },
    initMap() {
      this.map = new AMap.Map("mapImages", {
        resizeEnable: true,
        zoom: 8,
        zooms: [3, 20],
        expandZoomRange: true,
        layers: [
          new AMap.TileLayer.Satellite(),
          // 路网
          //   new AMap.TileLayer.RoadNet(),
        ],
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        let scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(scale);
      });
      // 添加区域边界线
      AMap.plugin("AMap.DistrictSearch", () => {
        let province = new AMap.DistrictSearch({
          extensions: "all",
          subdistrict: 2,
          level: "province",
        });
        let district = new AMap.DistrictSearch({
          extensions: "all",
          level: "district",
        });
        province.search("浙江省", (status, result) => {
          if (status === "complete") {
            let cityList = result.districtList[0].districtList;
            let labelsLayer = new AMap.LabelsLayer({
              collision: false,
              animation: true,
              zIndex: 100, // 确保标注层在行政区划之上
            });
            let allPolygons = []; // 存储所有多边形
            let processedCount = 0; // 处理计数器
            let totalCount = 0; // 总区县数
            // 先计算总区县数量
            cityList.forEach((city) => {
              totalCount += city.districtList.length;
            });
            cityList.forEach((city) => {
              city.districtList.forEach((county) => {
                // 1. 添加文本标注
                let labelsMarker = new AMap.LabelMarker({
                  name: county.name,
                  position: county.center,
                  text: {
                    content: county.name,
                    direction: "center",
                    style: {
                      fontSize: 12,
                      fillColor: "#333",
                      strokeColor: "#fff",
                      strokeWidth: 2,
                    },
                  },
                  icon: {
                    type: "image",
                    image:
                      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPg==",
                    size: [1, 1],
                    anchor: "center",
                  },
                });
                labelsLayer.add(labelsMarker);
                // 2. 查询并绘制边界（使用adcode更准确）
                setTimeout(() => {
                  district.search(
                    county.adcode || county.name,
                    (status, result) => {
                      processedCount++;
                      if (status === "complete") {
                        let boundaries = result.districtList[0].boundaries;
                        boundaries.forEach((boundary) => {
                          let polygon = new AMap.Polyline({
                            map: this.map,
                            strokeWeight: 1,
                            path: boundary,
                            fillOpacity: 0.3, // 设置透明度，避免完全覆盖
                            fillColor: "#000",
                            strokeColor: "#CC66CC",
                            zIndex: 100, // 确保在标注层之下
                            bubble: true, // 允许事件穿透
                          });
                          allPolygons.push(polygon);
                        });
                      }
                      // 所有区县处理完成后调整视图
                      if (
                        processedCount === totalCount &&
                        allPolygons.length > 0
                      ) {
                        // this.map.setFitView();
                      }
                    }
                  );
                }, processedCount * 100); // 分批延迟执行，避免请求过于密集
              });
            });
            // 将标注层添加到地图
            this.map.add(labelsLayer);
          }
        });
      });
      // 拍摄点窗体
      this.pointInfoWindow = new AMap.InfoWindow({
        anchor: "bottom-center",
        isCustom: true,
        showShadow: true,
        closeWhenClickMap: true, // 控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
        content: this.$refs.pointInfoWindow,
        offset: new AMap.Pixel(0, -38),
        retainWhenClose: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 100%;
  #mapImages {
    width: 100%;
    height: 100%;
    min-height: 720px;
  }
  /deep/ .red-marker {
    width: 16px;
    height: 16px;
    background-color: red;
    border-radius: 50%;
  }
  /deep/ .blue-marker {
    width: 16px;
    height: 16px;
    background-color: #0094ff;
    border-radius: 50%;
  }
  .el-icon-close {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    &.cive {
      cursor: pointer;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      font-weight: 600;
      color: #fff;
      background: #0094ff;
      border-radius: 50%;
      margin-bottom: 20px;
    }
  }
  .windowBox {
    width: 350px;
    min-height: 770px;
    background: url("../../../../assets/images/monitor/left_rightBox.png")
      no-repeat;
    background-size: 350px 770px;
    object-fit: contain;
    position: absolute;
    top: 80px;
    right: 20px;
    font-size: 12px;
    padding: 20px 10px;
    box-sizing: border-box;
    z-index: 999;
    .point-title {
      width: calc(100% - 10px);
      height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      font-weight: 600;
      span {
        color: #97abea;
        font-size: 14px;
        padding-bottom: 16px;
      }
    }
    .point-content {
      color: #fff;
      padding: 0 10px;
      .text {
        padding: 10px 10px 15px;
        color: #ccc;
        .el-row {
          padding-bottom: 10px;
        }
      }

      .tag {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 13px;
      }
    }
  }
  .point-infoWindow {
    width: 220px;
    min-height: 80px;
    font-size: 14px;
    color: #333;
    background: rgba($color: #fff, $alpha: 0.6);
    opacity: 0.9;
    border-radius: 4px;
    .pointInfo-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 24px;
      font-weight: 600;
      padding: 0 10px;
      background: #f2f2f2;
    }
    .pointInfo-content {
      min-height: 60px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .pointInfo-footer {
      padding: 10px;
      border-top: 1px solid #ccc;
    }
    // 三角形
    .delta {
      position: absolute;
      left: calc(50% - 10px);
      bottom: 0;
      width: 0;
      height: 0;
      border-top: 8px solid rgba($color: #fff, $alpha: 0.6);
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
    }
  }
  .vehicle-infoWindow {
    position: relative;
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    width: 185px;
    border-radius: 4px;
    box-sizing: border-box;
    .orderTime {
      position: absolute;
      width: 185px;
      line-height: 20px;
      background: rgba(255, 255, 255, 0.8);
      top: -22px;
      left: 0;
      border-radius: 3px;
      padding-left: 10px;
    }
    .infoWindow-detail {
      .carNumber {
        color: #0060ff;
      }
      .vehicleStatus {
        span {
          display: inline-block;
          text-align: center;
          width: 54px;
          height: 20px;
          border-radius: 10px;
          margin-right: 5px;
          color: rgba(255, 255, 255, 0.8);
        }
        .powering {
          background: #00beda;
        }
        .fueling {
          background: #ffa200;
        }
        .routing {
          background: #00cb4c;
        }
        .no-receive {
          background: #888888;
        }
        .no-order {
          background: #0078ff;
        }
      }
    }
    // 三角形
    .delta {
      position: absolute;
      left: -10px;
      top: 30px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 10px solid rgba(255, 255, 255, 0.8);
      border-bottom: 8px solid transparent;
    }
    // 查看详情
    .checkDetail {
      position: absolute;
      right: -30px;
      top: 0;
      width: 20px;
      height: 82px;
      background: rgba(0, 148, 255, 0.8);
      border-radius: 0px 3px 3px 0px;
      color: #fff;
      text-align: center;
      padding: 5px;
      cursor: pointer;
    }
  }
  /deep/ .details .el-dialog {
    width: 660px;
    .el-dialog__body {
      max-height: 600px;
      overflow-y: auto;
    }
  }
  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    padding-right: 20px;
  }
  .dialog-label {
    display: block;
    width: 100%;
    height: 84vh;
  }
  .details {
    .details-content {
      .details-title {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .environmental {
        text-align: center;
        margin-bottom: 10px;
      }
      .image-list {
        margin-top: 10px;
        text-align: center;
      }
      /deep/ .el-image__error {
        min-height: 200px;
        line-height: 200px;
      }
      .label {
        color: #333;
        width: 150px;
        flex-shrink: 0;
      }
      .el-row {
        display: flex;
        align-items: center;
        height: 32px;
        .text {
          display: inline-block;
          color: #666;
        }
      }
      .table-row {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 10px 0;
        .label {
          width: 100%;
          line-height: 32px;
        }
        /deep/ .el-table--border::after {
          background-color: #ccc;
        }
        /deep/ .el-table {
          width: 490px;
          flex: none;
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          td:first-child .cell,
          th:first-child .cell {
            padding-left: 0;
          }
          .cell {
            white-space: nowrap;
            overflow: visible;
          }
          th,
          td {
            background: #fff;
            color: #666;
            font-size: 12px;
            font-weight: 400;
            padding: 0;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
          }
        }
      }
    }
  }
  /deep/ .amap-scalecontrol {
    margin-left: 10px;
    .amap-scale-text {
      color: #fff !important;
    }
  }
}
</style>
